import { Arguments } from '@antistatique/cpef-calculator';

export const fieldsList: (keyof Arguments)[] = [
  'avoirReg',
  'choixDuPlan',
  'dateCertificat',
  'dateNaissance',
  'dateRetraite',
  'mesuresTrans',
  'retraiteApres65',
  'salaireAVS',
  'txAct',
  'txCrd',
  'rachatDate',
  'rachatMontant',
  'vaDate',
  'vaMontant',
];

export const numberFields: (keyof Arguments)[] = [
  'avoirReg',
  'mesuresTrans',
  'salaireAVS',
  'txAct',
  'txCrd',
  'rachatMontant',
  'vaMontant',
];

export const dateFields: (keyof Arguments)[] = [
  'dateCertificat',
  'dateNaissance',
  'dateRetraite',
  'rachatDate',
  'vaDate',
];

export const defaultFields: Partial<Arguments> = {
  avoirReg: 0,
  mesuresTrans: 0,
  txCrd: 0.0125,
  retraiteApres65: false,
};
